mutation DripSequenceGoalSet($input: DripSequenceGoalSetInput!) {
    dripSequenceGoalSet(input: $input) {
        campaign {
            id
        }
    }
}
